import { render, staticRenderFns } from "./AccountToAccountTransferForm.vue?vue&type=template&id=78f986cf"
import script from "./AccountToAccountTransferForm.vue?vue&type=script&lang=js"
export * from "./AccountToAccountTransferForm.vue?vue&type=script&lang=js"
import style0 from "./AccountToAccountTransferForm.vue?vue&type=style&index=0&id=78f986cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports